import React from 'react';
import {
  GridLegacy as Grid,
  TextField
} from '@mui/material';

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {}
});

const NoteDisputeForm = props => {
  const { className, reason, onChange, account_view, ...rest } = props;
  
  let title = "Note or Record Delete Request"
  if (account_view) {
    title = "Note or Record Delete Request"
  }

  const classes = useClasses(styles);

  

  return (
    <Grid
      container
      spacing={3}
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <TextField
          fullWidth
          label="Why should this note or record be deleted?"
          margin="dense"
          name="reason"
          onChange={(event) => onChange(event, 'reason')}
          required
          value={reason || ''}
          variant="outlined"
        />
      </Grid>
    </Grid>
  );
};


export default withErrorHandler(NoteDisputeForm, axios)